'use client';
import { useState } from 'react';

export default function CalculatorMortgagePayoff() {
  const [loanAmount, setLoanAmount] = useState(300000);
  const [interestRate, setInterestRate] = useState(6.5);
  const [loanTerm, setLoanTerm] = useState(30);
  const [extraPayment, setExtraPayment] = useState(200);

  const monthlyRate = interestRate / 100 / 12;
  const months = loanTerm * 12;
  const monthlyPayment = loanAmount * (monthlyRate * Math.pow(1 + monthlyRate, months)) / (Math.pow(1 + monthlyRate, months) - 1);
  const totalWithExtra = monthlyPayment + extraPayment;
  const interestSaved = (monthlyPayment * months) - (totalWithExtra * months * 0.8);

  return (
    <div className="bg-white rounded-3xl p-8 shadow-modern-xl">
      <h2 className="text-2xl font-bold mb-6">Payoff Details</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold mb-2">Current Loan Balance</label>
          <input type="number" value={loanAmount} onChange={(e) => setLoanAmount(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Interest Rate (%)</label>
          <input type="number" step="0.1" value={interestRate} onChange={(e) => setInterestRate(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Remaining Term (years)</label>
          <input type="number" value={loanTerm} onChange={(e) => setLoanTerm(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Extra Monthly Payment</label>
          <input type="number" value={extraPayment} onChange={(e) => setExtraPayment(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
      </div>
      <div className="mt-8 p-6 bg-emerald-50 rounded-xl">
        <h3 className="text-lg font-bold mb-2">Interest Saved</h3>
        <p className="text-3xl font-bold text-emerald-600">${interestSaved?.toFixed(2)}</p>
      </div>
    </div>
  );
}
